import axiosInstance from "../../axiosInstance";

/**
 * Upload journal cover image
 * @param {*} file
 * @returns
 */
const uploadJournalCoverImage = async (file) => {
  try {
    const res = await axiosInstance.post(
      `/api/document/upload/journalCoverImage`,
      file
    );

    if (res.status === 200) {
      return res.data;
    } else {
    }
  } catch (error) {}
};

const journalFiles = {
  uploadJournalCoverImage,
};

export default journalFiles;
